import React from 'react';
import ReactMarkdown from 'react-markdown';

import ShortCode from './ShortCode';

interface MarkdownProps {
  source: string;
}

function Markdown({source}: MarkdownProps) {
  const plugins = [
    [
      require('remark-shortcodes'), {
        startBlock: '[[',
        endBlock: ']]',
        inlineMode: true,
      },
    ],
  ];
  return (
    <ReactMarkdown plugins={plugins} renderers={{'shortcode': ShortCode}} source={source} />
  );
}

export default Markdown;
